import * as iD from './index';
window.iD = iD;
